import { FC } from "react";
import {
	Box,
	Card,
	CardContent,
	Typography,
	useTheme,
	useMediaQuery,
} from "@mui/material";

import { LoginJWT } from "src/components/authentication/login";
import { useTranslation } from "react-i18next";

const Login: FC = () => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));

	const styles = {
		root: {
			display: "flex",
			flexDirection: isMobile ? "column" : "row",
			alignItems: "stretch",
			minHeight: "100vh",
			bgcolor: theme.palette.mode === "dark" ? "#121212" : "#f3f5f9",
		},
		leftPanel: {
			flex: 1,
			backgroundColor:
				theme.palette.mode === "dark" ? "#1e1e1e" : "#ffffff",
			color: theme.palette.mode === "dark" ? "#fff" : "#000",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			p: isMobile ? 4 : 6,
			textAlign: "center",
			borderRight: isMobile ? 0 : `1px solid ${theme.palette.divider}`,
			boxShadow: isMobile ? "none" : "inset -1px 0 0 rgba(0,0,0,0.1)",
		},
		logo: {
			maxWidth: 160,
			marginBottom: 40,
		},
		illustration: {
			maxWidth: "80%",
			maxHeight: 320,
			marginBottom: 30,
		},
		rightPanel: {
			flex: 1,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			p: isMobile ? 4 : 0,
		},
		card: {
			p: isMobile ? 4 : 5,
			borderRadius: 4,
			textAlign: "center",
		},
	};

	const logoSrc =
		theme.palette.mode === "dark"
			? "/static/CC4TeamsLogoWhite.png"
			: "/static/CC4TeamsLogo.png";

	return (
		<Box sx={styles.root}>
			{/* Left Side Content */}
			<Box sx={styles.leftPanel}>
				<img
					src={logoSrc}
					alt="CC4Teams Logo"
					style={styles.logo}
					data-testid="login-logo"
				/>
				<img
					src="/static/cc4all_login.jpg"
					alt="Contact Center Illustration"
					style={styles.illustration}
				/>
				<Typography
					variant="h4"
					fontWeight="bold"
					gutterBottom
					data-testid="login-welcome-heading"
				>
					{t("Login.WelcomeBack")}
				</Typography>
				<Typography
					variant="body1"
					sx={{ maxWidth: 450, whiteSpace: "pre-line" }}
					data-testid="login-welcome-description"
				>
					{t("Login.WelcomeBackSubtitle")}
				</Typography>
			</Box>

			{/* Right Side Login Button */}
			<Box sx={styles.rightPanel}>
				<Card elevation={6} sx={styles.card}>
					<CardContent>
						<Typography variant="h5" fontWeight={600} gutterBottom>
							{t("Login.Login")}
						</Typography>
						<Typography
							variant="body2"
							color={
								theme.palette.mode === "dark"
									? "grey.400"
									: "text.secondary"
							}
							mb={3}
						>
							{t("Login.LoginToAccount")}
						</Typography>
						<LoginJWT />
					</CardContent>
				</Card>
			</Box>
		</Box>
	);
};

export default Login;
